import React from 'react'
import { Form, Input } from 'antd'

export const FormInput = ({
  editable,
  name,
  message,
  initialValue = null,
  width = '100%',
  required = false,
  ...others
}) => {
  if (!editable) return initialValue
  return (
    <Form.Item name={name} rules={[{ required: required, message: message }]}>
      <Input style={{ width: width }} {...others} />
    </Form.Item>
  )
}
